// Fragment "receipts (B75)" — tax receipt view/resend actions on InvoicesAdmin.jsx.
// Fusionné dans ./index.js.
export default {
  fr: {
    "invoices.actions.viewReceipt": "Voir le reçu fiscal",
    "invoices.actions.resendReceipt": "Renvoyer le reçu par courriel",
    "invoices.receiptResent": "Reçu fiscal renvoyé à {email}.",
    "invoices.receiptResendError": "Échec de l'envoi du reçu fiscal.",
  },
  en: {
    "invoices.actions.viewReceipt": "View tax receipt",
    "invoices.actions.resendReceipt": "Resend receipt email",
    "invoices.receiptResent": "Tax receipt resent to {email}.",
    "invoices.receiptResendError": "Failed to resend the tax receipt.",
  },
  es: {
    "invoices.actions.viewReceipt": "Ver recibo fiscal",
    "invoices.actions.resendReceipt": "Reenviar recibo por correo",
    "invoices.receiptResent": "Recibo fiscal reenviado a {email}.",
    "invoices.receiptResendError": "No se pudo reenviar el recibo fiscal.",
  },
};
